var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_101_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.55556 3.33341H12.4444V8.66675H3.55556V3.33341ZM14.6667 6.00008C14.6667 6.73647 15.2636 7.33341 16 7.33341V10.0001C16 10.7365 15.4031 11.3334 14.6667 11.3334H1.33333C0.596944 11.3334 0 10.7365 0 10.0001V7.33341C0.736389 7.33341 1.33333 6.73647 1.33333 6.00008C1.33333 5.26369 0.736389 4.66675 0 4.66675V2.00008C0 1.26369 0.596944 0.666748 1.33333 0.666748H14.6667C15.4031 0.666748 16 1.26369 16 2.00008V4.66675C15.2636 4.66675 14.6667 5.26369 14.6667 6.00008ZM13.3333 3.11119C13.3333 2.743 13.0349 2.44453 12.6667 2.44453H3.33333C2.96514 2.44453 2.66667 2.743 2.66667 3.11119V8.88897C2.66667 9.25716 2.96514 9.55564 3.33333 9.55564H12.6667C13.0349 9.55564 13.3333 9.25716 13.3333 8.88897V3.11119Z",
    fill: "#DDE2FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_101_29",
    x: -4,
    y: 0.666748,
    width: 24,
    height: 18.6667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_29"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_29",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuTicket);
export default __webpack_public_path__ + "static/media/menu-ticket.ad46a01925606300e3de158d293418a6.svg";
export { ForwardRef as ReactComponent };